"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_APP_DEVELOPMENT_NODE_CONFIG_MATRIX = exports.CustomAppDevelopmentPlanInputSchema = exports.CustomAppDevelopmentTypedOverridesSchema = exports.CustomAppDevelopmentTypedOverrideSchema = exports.CustomAppDevelopmentTypedChoicesSchema = exports.CustomAppDevelopmentBindingsSchema = exports.CustomAppDevelopmentIntentSchema = exports.CustomAppDevelopmentSmokeResultSchema = exports.CustomAppDevelopmentSmokeCheckSchema = exports.CustomAppDevelopmentApplyResultSchema = exports.CustomAppDevelopmentStatusSchema = exports.CustomAppDevelopmentValidationResultSchema = exports.CustomAppDevelopmentTreeSchema = exports.CustomAppDevelopmentNodeSchema = exports.CustomAppDevelopmentProgressSchema = exports.CustomAppDevelopmentRecipeSchema = exports.CustomAppDevelopmentConfirmationLedgerSchema = exports.CustomAppDevelopmentRecipeMutationSchema = exports.CustomAppDevelopmentDiffSchema = exports.CustomAppDevelopmentDiffEntrySchema = exports.CustomAppDevelopmentNextStepSchema = exports.CustomAppDevelopmentGapExplanationSchema = exports.CustomAppDevelopmentGapSchema = exports.CustomAppDiagnosticReportSchema = exports.CustomAppDiagnosticSchema = exports.CustomAppDiagnosticActionSchema = exports.CustomAppDiagnosticScopeSchema = exports.CustomAppDiagnosticSeveritySchema = exports.CustomAppDiagnosticStageSchema = exports.CustomAppDevelopmentValidationErrorSchema = exports.CustomAppDevelopmentTargetSchema = exports.CustomAppDevelopmentJsonValueSchema = exports.CustomAppDevelopmentValueSchema = exports.CustomAppDevelopmentObjectValueSchema = exports.CustomAppDevelopmentScalarValueSchema = exports.CustomAppDevelopmentSmokeCheckStatusSchema = exports.CustomAppDevelopmentDiffImpactSchema = exports.CustomAppDevelopmentNextStepActionKindSchema = exports.CustomAppDevelopmentGapSeveritySchema = exports.CustomAppDevelopmentNodeKindSchema = exports.CustomAppDevelopmentValueKindSchema = exports.CustomAppDevelopmentValueSourceSchema = exports.CustomAppDevelopmentNodeStatusSchema = exports.CUSTOM_APP_DEVELOPMENT_MODES = exports.CustomAppDevelopmentModeSchema = exports.CUSTOM_APP_DEVELOPMENT_TREE_SCHEMA_VERSION = void 0;
exports.createCustomAppDevelopmentNextStep = createCustomAppDevelopmentNextStep;
exports.createCustomAppDevelopmentGap = createCustomAppDevelopmentGap;
exports.createCustomAppDevelopmentNode = createCustomAppDevelopmentNode;
exports.deriveCustomAppDevelopmentNodeStatus = deriveCustomAppDevelopmentNodeStatus;
exports.calculateCustomAppDevelopmentProgress = calculateCustomAppDevelopmentProgress;
exports.collectCustomAppDevelopmentGaps = collectCustomAppDevelopmentGaps;
exports.collectCustomAppDevelopmentNextSteps = collectCustomAppDevelopmentNextSteps;
exports.finalizeCustomAppDevelopmentTree = finalizeCustomAppDevelopmentTree;
const zod_1 = require("zod");
const custom_app_config_1 = require("./custom-app-config");
const custom_app_contract_1 = require("./custom-app-contract");
exports.CUSTOM_APP_DEVELOPMENT_TREE_SCHEMA_VERSION = 1;
exports.CustomAppDevelopmentModeSchema = zod_1.z.enum([
    'create_app_from_scratch',
    'create_app_block',
    'instantiate_marketplace_app_block',
    'add_app_block',
    'edit_app_block',
    'edit_mount',
    'replace_app_block',
    'unmount_app_block',
    'delete_app_block',
    'bind_database',
    'rebind_database',
    'bind_automation',
    'bind_export',
    'configure_attachments',
    'change_visibility',
    'inspect_status',
    'smoke_test_app',
    'publish_app',
]);
exports.CUSTOM_APP_DEVELOPMENT_MODES = exports.CustomAppDevelopmentModeSchema.options;
exports.CustomAppDevelopmentNodeStatusSchema = zod_1.z.enum([
    'missing',
    'defaulted',
    'configured',
    'invalid',
    'ready',
]);
exports.CustomAppDevelopmentValueSourceSchema = zod_1.z.enum([
    'system',
    'developer',
    'derived',
    'binding',
]);
exports.CustomAppDevelopmentValueKindSchema = zod_1.z.enum([
    'freeIntent',
    'freeContent',
    'typedChoice',
    'typedOverride',
    'workspaceBinding',
    'systemDefault',
    'derived',
]);
exports.CustomAppDevelopmentNodeKindSchema = zod_1.z.enum([
    'app',
    'shell',
    'exposure',
    'composition',
    'mount',
    'appBlock',
    'route',
    'file',
    'resource',
    'databaseRequirement',
    'columnRequirement',
    'binding',
    'command',
    'automationBinding',
    'export',
    'seo',
    'operatorControl',
    'health',
    'publish',
]);
exports.CustomAppDevelopmentGapSeveritySchema = zod_1.z.enum([
    'info',
    'warning',
    'blocking',
]);
exports.CustomAppDevelopmentNextStepActionKindSchema = zod_1.z.enum([
    'set_intent',
    'choose_typed_value',
    'bind_workspace_entity',
    'accept_default',
    'provide_override_reason',
    'repair',
    'run_smoke_test',
    'publish',
]);
exports.CustomAppDevelopmentDiffImpactSchema = zod_1.z.enum([
    'none',
    'runtime',
    'data',
    'permission',
    'publish',
    'seo',
]);
exports.CustomAppDevelopmentSmokeCheckStatusSchema = zod_1.z.enum([
    'pass',
    'fail',
    'skip',
]);
exports.CustomAppDevelopmentScalarValueSchema = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.null(),
]);
exports.CustomAppDevelopmentObjectValueSchema = zod_1.z.record(zod_1.z.union([
    exports.CustomAppDevelopmentScalarValueSchema,
    zod_1.z.array(exports.CustomAppDevelopmentScalarValueSchema),
]));
exports.CustomAppDevelopmentValueSchema = zod_1.z.union([
    exports.CustomAppDevelopmentScalarValueSchema,
    zod_1.z.array(exports.CustomAppDevelopmentScalarValueSchema),
    exports.CustomAppDevelopmentObjectValueSchema,
]);
exports.CustomAppDevelopmentJsonValueSchema = zod_1.z.lazy(() => zod_1.z.union([
    exports.CustomAppDevelopmentScalarValueSchema,
    zod_1.z.array(exports.CustomAppDevelopmentJsonValueSchema),
    zod_1.z.record(exports.CustomAppDevelopmentJsonValueSchema),
]));
exports.CustomAppDevelopmentTargetSchema = zod_1.z
    .object({
    customAppId: zod_1.z.string().min(1).optional(),
    appBlockId: zod_1.z.string().min(1).optional(),
    rootDocId: zod_1.z.string().min(1).optional(),
    marketplaceTemplateId: zod_1.z.string().min(1).optional(),
    marketplaceTargetKind: zod_1.z.enum(['existing_app', 'new_app']).optional(),
    marketplaceTargetSlug: zod_1.z.string().min(2).max(63).optional(),
    marketplaceOperationId: zod_1.z.string().min(8).optional(),
    marketplaceConfirmedPreflightDigest: zod_1.z.string().length(64).optional(),
    marketplaceTargetRootRoutePath: zod_1.z.string().min(1).optional(),
    marketplaceTargetVersionNumber: zod_1.z.number().int().positive().optional(),
    marketplaceDatabaseMappings: zod_1.z
        .record(zod_1.z.discriminatedUnion('action', [
        zod_1.z.object({ action: zod_1.z.literal('create_new') }).strict(),
        zod_1.z
            .object({
            action: zod_1.z.literal('use_existing'),
            target: zod_1.z.string().min(1),
        })
            .strict(),
    ]))
        .optional(),
})
    .strict();
exports.CustomAppDevelopmentValidationErrorSchema = zod_1.z
    .object({
    code: zod_1.z.string().min(1),
    message: zod_1.z.string().min(1),
    path: zod_1.z.array(zod_1.z.string().min(1)),
})
    .strict();
exports.CustomAppDiagnosticStageSchema = zod_1.z.enum([
    'authoring',
    'static_validation',
    'installation',
    'preview_boot',
    'route_loading',
    'data_loading',
    'interaction',
    'publish',
]);
exports.CustomAppDiagnosticSeveritySchema = zod_1.z.enum([
    'info',
    'warning',
    'error',
]);
exports.CustomAppDiagnosticScopeSchema = zod_1.z
    .object({
    appBlockId: zod_1.z.string().min(1).optional(),
    routePath: zod_1.z.string().min(1).optional(),
    pageId: zod_1.z.string().min(1).optional(),
    sourceKey: zod_1.z.string().min(1).optional(),
    actionId: zod_1.z.string().min(1).optional(),
    controlId: zod_1.z.string().min(1).optional(),
    filePath: zod_1.z.string().min(1).optional(),
    nodeId: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.CustomAppDiagnosticActionSchema = zod_1.z
    .object({
    action: zod_1.z.enum(['repair_with_ai', 'retry', 'inspect', 'validate', 'smoke']),
    label: zod_1.z.string().min(1),
    allowedTool: zod_1.z.string().min(1).optional(),
})
    .strict();
/**
 * One safe, channel-neutral diagnostic. UI, Copilot and external MCP agents
 * consume this exact contract; context pills are presentation only.
 */
exports.CustomAppDiagnosticSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    diagnosticId: zod_1.z.string().min(8),
    code: zod_1.z.string().min(1),
    severity: exports.CustomAppDiagnosticSeveritySchema,
    stage: exports.CustomAppDiagnosticStageSchema,
    blocking: zod_1.z.boolean(),
    retryable: zod_1.z.boolean(),
    message: zod_1.z.string().min(1),
    technicalDetail: zod_1.z.string().min(1).max(1000).optional(),
    target: exports.CustomAppDevelopmentTargetSchema,
    scope: exports.CustomAppDiagnosticScopeSchema.default({}),
    durationMs: zod_1.z.number().int().nonnegative().optional(),
    suggestedActions: zod_1.z.array(exports.CustomAppDiagnosticActionSchema),
})
    .strict();
exports.CustomAppDiagnosticReportSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(1),
    status: zod_1.z.enum(['pass', 'warning', 'fail']),
    target: exports.CustomAppDevelopmentTargetSchema,
    diagnostics: zod_1.z.array(exports.CustomAppDiagnosticSchema),
    generatedAt: zod_1.z.string().datetime(),
})
    .strict();
exports.CustomAppDevelopmentGapSchema = zod_1.z
    .object({
    gapId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    severity: exports.CustomAppDevelopmentGapSeveritySchema,
    blocking: zod_1.z.boolean(),
    reason: zod_1.z.string().min(1),
    requiredValueKind: exports.CustomAppDevelopmentValueKindSchema.optional(),
    expectedSchemaRef: zod_1.z.string().min(1).optional(),
    allowedActions: zod_1.z.array(zod_1.z.string().min(1)),
})
    .strict();
exports.CustomAppDevelopmentGapExplanationSchema = zod_1.z
    .object({
    gapId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    reason: zod_1.z.string().min(1),
    resolution: zod_1.z.string().min(1),
    allowedActions: zod_1.z.array(zod_1.z.string().min(1)),
})
    .strict();
exports.CustomAppDevelopmentNextStepSchema = zod_1.z
    .object({
    nextStepId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    actionKind: exports.CustomAppDevelopmentNextStepActionKindSchema,
    label: zod_1.z.string().min(1),
    allowedTool: zod_1.z.string().min(1).optional(),
    requiredConfirmation: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.CustomAppDevelopmentDiffEntrySchema = zod_1.z
    .object({
    nodeId: zod_1.z.string().min(1),
    field: zod_1.z.string().min(1),
    oldValue: exports.CustomAppDevelopmentValueSchema.optional(),
    newValue: exports.CustomAppDevelopmentValueSchema.optional(),
    impact: exports.CustomAppDevelopmentDiffImpactSchema,
})
    .strict();
exports.CustomAppDevelopmentDiffSchema = zod_1.z
    .object({
    entries: zod_1.z.array(exports.CustomAppDevelopmentDiffEntrySchema),
})
    .strict();
exports.CustomAppDevelopmentRecipeMutationSchema = zod_1.z
    .object({
    mutationId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    type: zod_1.z.string().min(1),
    input: exports.CustomAppDevelopmentJsonValueSchema.optional(),
    confirmationKey: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.CustomAppDevelopmentConfirmationLedgerSchema = zod_1.z
    .object({
    required: zod_1.z.array(zod_1.z.string().min(1)),
    accepted: zod_1.z.array(zod_1.z.string().min(1)).default([]),
})
    .strict();
exports.CustomAppDevelopmentRecipeSchema = zod_1.z
    .object({
    recipeId: zod_1.z.string().min(1),
    mode: exports.CustomAppDevelopmentModeSchema,
    mutations: zod_1.z.array(exports.CustomAppDevelopmentRecipeMutationSchema),
    confirmationLedger: exports.CustomAppDevelopmentConfirmationLedgerSchema,
})
    .strict();
exports.CustomAppDevelopmentProgressSchema = zod_1.z
    .object({
    ready: zod_1.z.number().int().nonnegative(),
    configured: zod_1.z.number().int().nonnegative(),
    defaulted: zod_1.z.number().int().nonnegative(),
    missing: zod_1.z.number().int().nonnegative(),
    invalid: zod_1.z.number().int().nonnegative(),
    total: zod_1.z.number().int().nonnegative(),
    blocking: zod_1.z.number().int().nonnegative(),
})
    .strict();
exports.CustomAppDevelopmentNodeSchema = zod_1.z.lazy(() => zod_1.z
    .object({
    nodeId: zod_1.z.string().min(1),
    kind: exports.CustomAppDevelopmentNodeKindSchema,
    label: zod_1.z.string().min(1),
    required: zod_1.z.boolean(),
    source: exports.CustomAppDevelopmentValueSourceSchema,
    valueKind: exports.CustomAppDevelopmentValueKindSchema,
    status: exports.CustomAppDevelopmentNodeStatusSchema,
    value: exports.CustomAppDevelopmentValueSchema.optional(),
    defaultValue: exports.CustomAppDevelopmentValueSchema.optional(),
    allowedValues: zod_1.z.array(exports.CustomAppDevelopmentValueSchema).optional(),
    schemaRef: zod_1.z.string().min(1).optional(),
    overrideReason: zod_1.z.string().min(1).optional(),
    validationErrors: zod_1.z.array(exports.CustomAppDevelopmentValidationErrorSchema),
    children: zod_1.z.array(exports.CustomAppDevelopmentNodeSchema),
    nextSteps: zod_1.z.array(exports.CustomAppDevelopmentNextStepSchema),
})
    .strict()
    .superRefine((node, ctx) => {
    if (node.valueKind === 'typedChoice') {
        const hasChoices = (node.allowedValues?.length ?? 0) > 0 || !!node.schemaRef;
        if (!hasChoices) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'typedChoice nodes require allowedValues or schemaRef',
                path: ['allowedValues'],
            });
        }
    }
    if (node.valueKind === 'typedOverride' &&
        (!node.schemaRef || !node.overrideReason)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'typedOverride nodes require both schemaRef and overrideReason',
            path: ['overrideReason'],
        });
    }
    if (node.valueKind === 'typedOverride' && node.source !== 'developer') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'typedOverride values must be developer sourced',
            path: ['source'],
        });
    }
    if ((node.valueKind === 'freeIntent' ||
        node.valueKind === 'freeContent') &&
        node.source !== 'developer') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'free values must be developer sourced',
            path: ['source'],
        });
    }
    if (node.valueKind === 'systemDefault' && node.source !== 'system') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'systemDefault values must be system sourced',
            path: ['source'],
        });
    }
    if (node.valueKind === 'derived' && node.source !== 'derived') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'derived values must be derived sourced',
            path: ['source'],
        });
    }
    if (node.valueKind === 'workspaceBinding' &&
        node.source !== 'binding') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'workspace bindings must be binding sourced',
            path: ['source'],
        });
    }
}));
exports.CustomAppDevelopmentTreeSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.CUSTOM_APP_DEVELOPMENT_TREE_SCHEMA_VERSION),
    target: exports.CustomAppDevelopmentTargetSchema,
    mode: exports.CustomAppDevelopmentModeSchema,
    root: exports.CustomAppDevelopmentNodeSchema,
    progress: exports.CustomAppDevelopmentProgressSchema,
    gaps: zod_1.z.array(exports.CustomAppDevelopmentGapSchema),
    nextSteps: zod_1.z.array(exports.CustomAppDevelopmentNextStepSchema),
    diff: exports.CustomAppDevelopmentDiffSchema.optional(),
    recipe: exports.CustomAppDevelopmentRecipeSchema.optional(),
})
    .strict();
exports.CustomAppDevelopmentValidationResultSchema = zod_1.z
    .object({
    valid: zod_1.z.boolean(),
    errors: zod_1.z.array(exports.CustomAppDevelopmentValidationErrorSchema),
    tree: exports.CustomAppDevelopmentTreeSchema,
})
    .strict();
exports.CustomAppDevelopmentStatusSchema = zod_1.z
    .object({
    target: exports.CustomAppDevelopmentTargetSchema,
    mode: exports.CustomAppDevelopmentModeSchema,
    progress: exports.CustomAppDevelopmentProgressSchema,
    gaps: zod_1.z.array(exports.CustomAppDevelopmentGapSchema),
    nextSteps: zod_1.z.array(exports.CustomAppDevelopmentNextStepSchema),
})
    .strict();
exports.CustomAppDevelopmentApplyResultSchema = zod_1.z
    .object({
    applied: zod_1.z.array(zod_1.z.string().min(1)),
    skipped: zod_1.z.array(zod_1.z
        .object({
        mutationId: zod_1.z.string().min(1),
        reason: zod_1.z.string().min(1),
    })
        .strict()),
    failed: zod_1.z.array(zod_1.z
        .object({
        mutationId: zod_1.z.string().min(1),
        reason: zod_1.z.string().min(1),
        nodeId: zod_1.z.string().min(1).optional(),
    })
        .strict()),
    summary: zod_1.z
        .object({
        customAppId: zod_1.z.string().min(1),
        appKind: zod_1.z.enum(['web', 'workspace']),
        exposureProfile: custom_app_contract_1.CustomAppExposureProfileSchema,
        routeCount: zod_1.z.number().int().nonnegative(),
        routes: zod_1.z.array(zod_1.z
            .object({
            path: zod_1.z.string().min(1),
            access: zod_1.z.string().min(1),
        })
            .strict()),
        capabilities: zod_1.z.array(zod_1.z.string().min(1)),
        dataSourceCount: zod_1.z.number().int().nonnegative(),
        dataSources: zod_1.z.array(zod_1.z
            .object({
            key: zod_1.z.string().min(1),
            role: zod_1.z.string().min(1),
        })
            .strict()),
        quota: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable(),
        quotaRemaining: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable(),
        planRestrictions: zod_1.z.array(zod_1.z.string().min(1)),
        incompatibilities: zod_1.z.array(zod_1.z.string().min(1)),
    })
        .strict()
        .optional(),
    tree: exports.CustomAppDevelopmentTreeSchema,
})
    .strict();
exports.CustomAppDevelopmentSmokeCheckSchema = zod_1.z
    .object({
    checkId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    status: exports.CustomAppDevelopmentSmokeCheckStatusSchema,
    failReason: zod_1.z.string().min(1).optional(),
    nextStepId: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.CustomAppDevelopmentSmokeResultSchema = zod_1.z
    .object({
    target: exports.CustomAppDevelopmentTargetSchema,
    status: exports.CustomAppDevelopmentSmokeCheckStatusSchema,
    checks: zod_1.z.array(exports.CustomAppDevelopmentSmokeCheckSchema),
    blockingFailures: zod_1.z.array(zod_1.z.string().min(1)),
    gaps: zod_1.z.array(exports.CustomAppDevelopmentGapSchema),
    nextSteps: zod_1.z.array(exports.CustomAppDevelopmentNextStepSchema),
    recipeId: zod_1.z.string().min(1).optional(),
    treeVersion: zod_1.z.number().int().positive().optional(),
    tree: exports.CustomAppDevelopmentTreeSchema.optional(),
})
    .strict();
exports.CustomAppDevelopmentIntentSchema = zod_1.z
    .object({
    title: zod_1.z.string().min(1).optional(),
    brief: zod_1.z.string().min(1).optional(),
    goals: zod_1.z.array(zod_1.z.string().min(1)).optional(),
    labels: zod_1.z.record(zod_1.z.string()).optional(),
    content: zod_1.z.record(exports.CustomAppDevelopmentValueSchema).optional(),
})
    .strict();
exports.CustomAppDevelopmentBindingsSchema = zod_1.z
    .object({
    databaseId: zod_1.z.string().min(1).optional(),
    viewId: zod_1.z.string().min(1).optional(),
    columnId: zod_1.z.string().min(1).optional(),
    automationId: zod_1.z.string().min(1).optional(),
    credentialId: zod_1.z.string().min(1).optional(),
    docId: zod_1.z.string().min(1).optional(),
    resourceId: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.CustomAppDevelopmentTypedChoicesSchema = zod_1.z
    .object({
    appKind: custom_app_contract_1.CustomAppKindSchema.optional(),
    resourceRole: custom_app_config_1.CustomAppDataSourceRoleSchema.optional(),
    contentModel: custom_app_config_1.CustomAppContentModelSchema.optional(),
    accessMode: zod_1.z.enum(['read', 'write']).optional(),
    commandType: zod_1.z
        .enum(['navigate', 'mutate_row', 'run_automation', 'export_document'])
        .optional(),
    publishOnApply: zod_1.z.boolean().optional(),
    navigationModel: zod_1.z.enum(['spa', 'multi-page']).optional(),
    navPlacement: zod_1.z.enum(['primary', 'secondary', 'hidden']).optional(),
    exportFormat: zod_1.z.enum(['pdf', 'csv', 'json', 'html']).optional(),
})
    .strict();
exports.CustomAppDevelopmentTypedOverrideSchema = zod_1.z
    .object({
    value: exports.CustomAppDevelopmentValueSchema,
    schemaRef: zod_1.z.string().min(1),
    overrideReason: zod_1.z.string().min(1),
})
    .strict();
exports.CustomAppDevelopmentTypedOverridesSchema = zod_1.z
    .record(zod_1.z.string().min(1), exports.CustomAppDevelopmentTypedOverrideSchema)
    .default({});
exports.CustomAppDevelopmentPlanInputSchema = zod_1.z
    .object({
    mode: exports.CustomAppDevelopmentModeSchema,
    target: exports.CustomAppDevelopmentTargetSchema.default({}),
    intent: exports.CustomAppDevelopmentIntentSchema.default({}),
    typedChoices: exports.CustomAppDevelopmentTypedChoicesSchema.default({}),
    bindings: exports.CustomAppDevelopmentBindingsSchema.default({}),
    overrides: exports.CustomAppDevelopmentTypedOverridesSchema,
    runtimeDiagnostic: exports.CustomAppDiagnosticSchema.optional(),
})
    .strict();
exports.CUSTOM_APP_DEVELOPMENT_NODE_CONFIG_MATRIX = [
    {
        kind: 'app',
        fields: ['appId', 'title', 'slug', 'rootDocId'],
        valueKinds: [
            'systemDefault',
            'freeIntent',
            'workspaceBinding',
            'typedOverride',
        ],
        defaultOwner: 'createAppDefaults',
        validator: 'doc/workspace access validator',
        overrideRule: 'slug override only as typedOverride with reason',
    },
    {
        kind: 'shell',
        fields: ['branding', 'navigationModel', 'navigationPolicy', 'localePolicy'],
        valueKinds: ['typedChoice', 'freeContent', 'typedOverride'],
        defaultOwner: 'createShellDefaults',
        validator: 'shell schema validator',
        overrideRule: 'schemaRef-valid typed overrides only',
    },
    {
        kind: 'exposure',
        fields: ['exposureProfile', 'delivery', 'auth', 'cache', 'robots'],
        valueKinds: ['typedChoice', 'derived'],
        defaultOwner: 'deriveExposureDefaults',
        validator: 'visibility compatibility validator',
        overrideRule: 'delivery is derived and not free-overridable',
    },
    {
        kind: 'composition',
        fields: ['mounts', 'order'],
        valueKinds: ['derived', 'systemDefault', 'typedOverride'],
        defaultOwner: 'deriveCompositionDefaults',
        validator: 'mount uniqueness validator',
        overrideRule: 'order typedOverride allowed with reason',
    },
    {
        kind: 'mount',
        fields: ['mountId', 'appBlockId', 'routePrefix', 'navPlacement'],
        valueKinds: [
            'systemDefault',
            'workspaceBinding',
            'typedChoice',
            'typedOverride',
        ],
        defaultOwner: 'createMountDefaults',
        validator: 'appBlock catalog and route conflict validator',
        overrideRule: 'routePrefix override as typedOverride with reason',
    },
    {
        kind: 'appBlock',
        fields: ['appBlockId', 'title', 'rootRoutePath', 'version'],
        valueKinds: ['systemDefault', 'freeIntent', 'typedOverride'],
        defaultOwner: 'createAppBlockDefaults',
        validator: 'AppBlockDefinition schema',
        overrideRule: 'public appBlockId override requires stable reason',
    },
    {
        kind: 'route',
        fields: ['routeId', 'path', 'moduleId', 'navLabel'],
        valueKinds: ['systemDefault', 'freeIntent', 'typedOverride'],
        defaultOwner: 'createRouteDefaults',
        validator: 'route path and module validator',
        overrideRule: 'path override as typedOverride with reason',
    },
    {
        kind: 'file',
        fields: ['fileId', 'path', 'mimeType', 'contentRef'],
        valueKinds: ['freeContent', 'systemDefault', 'derived', 'typedOverride'],
        defaultOwner: 'createArtifactFileDefaults',
        validator: 'artifact file validator',
        overrideRule: 'file path override as typedOverride with reason',
    },
    {
        kind: 'resource',
        fields: ['sourceKey', 'role', 'contentModel', 'accessMode'],
        valueKinds: ['systemDefault', 'typedChoice', 'typedOverride'],
        defaultOwner: 'createResourceDefaults',
        validator: 'resource requirement validator',
        overrideRule: 'sourceKey override as typedOverride with reason',
    },
    {
        kind: 'databaseRequirement',
        fields: ['sourceKey', 'label', 'role', 'contentModel', 'rowWindow'],
        valueKinds: ['systemDefault', 'typedChoice', 'workspaceBinding'],
        defaultOwner: 'createDatabaseRequirementDefaults',
        validator: 'database requirement validator',
        overrideRule: 'requirements stay typed; databaseId is a binding node',
    },
    {
        kind: 'columnRequirement',
        fields: [
            'sourceKey',
            'columnSemanticKey',
            'type',
            'required',
            'options',
            'targetDatabaseId',
            'inverseFieldId',
            'cardinality',
        ],
        valueKinds: ['systemDefault', 'typedChoice', 'workspaceBinding'],
        defaultOwner: 'createColumnRequirementDefaults',
        validator: 'semantic column type and relation contract validator',
        overrideRule: 'columnId comes only from workspace bindings; controlled vocabularies require options and relations require target, inverse field, and cardinality',
    },
    {
        kind: 'binding',
        fields: [
            'databaseId',
            'viewId',
            'columnId',
            'automationId',
            'credentialId',
            'docId',
        ],
        valueKinds: ['workspaceBinding'],
        defaultOwner: 'createBindingSkeleton',
        validator: 'workspace entity access validator',
        overrideRule: 'bindings only from workspace state',
    },
    {
        kind: 'command',
        fields: ['commandId', 'type', 'inputBindings', 'resultPresentation'],
        valueKinds: [
            'systemDefault',
            'typedChoice',
            'workspaceBinding',
            'typedOverride',
        ],
        defaultOwner: 'createCommandDefaults',
        validator: 'command/action capability validator',
        overrideRule: 'commandId override as typedOverride with reason',
    },
    {
        kind: 'automationBinding',
        fields: ['automationId', 'trigger', 'inputMapping', 'credentialId'],
        valueKinds: ['workspaceBinding', 'typedChoice'],
        defaultOwner: 'createAutomationBindingSkeleton',
        validator: 'automation and credential access validator',
        overrideRule: 'automation linkage only from workspace state',
    },
    {
        kind: 'export',
        fields: ['exportId', 'format', 'routePath', 'targetActionId'],
        valueKinds: ['systemDefault', 'typedChoice', 'typedOverride'],
        defaultOwner: 'createExportDefaults',
        validator: 'export capability validator',
        overrideRule: 'exportId override as typedOverride with reason',
    },
    {
        kind: 'seo',
        fields: ['title', 'description', 'robots', 'llms', 'structuredData'],
        valueKinds: ['freeContent', 'derived', 'typedChoice'],
        defaultOwner: 'deriveSeoDefaults',
        validator: 'exposure SEO/AIO validator',
        overrideRule: 'robots override gated by exposure',
    },
    {
        kind: 'operatorControl',
        fields: ['controlId', 'controlType', 'targetNodeId'],
        valueKinds: ['systemDefault', 'derived'],
        defaultOwner: 'deriveOperatorControls',
        validator: 'semantic control validator',
        overrideRule: 'no free override',
    },
    {
        kind: 'health',
        fields: [
            'config',
            'composition',
            'mainMount',
            'artifact',
            'dataBinding',
            'interaction',
            'live',
        ],
        valueKinds: ['derived'],
        defaultOwner: 'inspectPersistedCustomAppHealth',
        validator: 'persisted builder/runtime/publish health validator',
        overrideRule: 'health is observed and cannot be overridden',
    },
    {
        kind: 'publish',
        fields: ['publishState', 'readiness', 'smokeChecks'],
        valueKinds: ['derived'],
        defaultOwner: 'derivePublishReadiness',
        validator: 'smoke/publish validator',
        overrideRule: 'no free override',
    },
];
function createCustomAppDevelopmentNextStep(input) {
    return exports.CustomAppDevelopmentNextStepSchema.parse({
        nextStepId: `${input.nodeId}:${input.actionKind}`,
        ...input,
    });
}
function createCustomAppDevelopmentGap(input) {
    const severity = input.severity ?? 'blocking';
    return exports.CustomAppDevelopmentGapSchema.parse({
        gapId: `${input.nodeId}:${input.requiredValueKind ?? severity}`,
        nodeId: input.nodeId,
        severity,
        blocking: severity === 'blocking',
        reason: input.reason,
        requiredValueKind: input.requiredValueKind,
        expectedSchemaRef: input.expectedSchemaRef,
        allowedActions: input.allowedActions,
    });
}
function createCustomAppDevelopmentNode(input) {
    const status = input.status ??
        deriveCustomAppDevelopmentNodeStatus({
            required: input.required ?? true,
            value: input.value,
            defaultValue: input.defaultValue,
            validationErrors: input.validationErrors ?? [],
        });
    return exports.CustomAppDevelopmentNodeSchema.parse({
        required: true,
        validationErrors: [],
        children: [],
        nextSteps: [],
        ...input,
        status,
    });
}
function deriveCustomAppDevelopmentNodeStatus(input) {
    if (input.validationErrors.length > 0)
        return 'invalid';
    if (input.value !== undefined)
        return 'configured';
    if (input.defaultValue !== undefined)
        return 'defaulted';
    return input.required ? 'missing' : 'ready';
}
function calculateCustomAppDevelopmentProgress(root) {
    const progress = {
        ready: 0,
        configured: 0,
        defaulted: 0,
        missing: 0,
        invalid: 0,
        total: 0,
        blocking: 0,
    };
    const visit = (node) => {
        progress.total++;
        progress[node.status]++;
        if (node.required &&
            (node.status === 'missing' || node.status === 'invalid')) {
            progress.blocking++;
        }
        for (const child of node.children)
            visit(child);
    };
    visit(root);
    return exports.CustomAppDevelopmentProgressSchema.parse(progress);
}
function collectCustomAppDevelopmentGaps(root) {
    const gaps = [];
    const visit = (node) => {
        if (node.status === 'missing' || node.status === 'invalid') {
            gaps.push(createCustomAppDevelopmentGap({
                nodeId: node.nodeId,
                severity: node.required ? 'blocking' : 'warning',
                reason: node.validationErrors[0]?.message ??
                    `${node.label} is ${node.status}`,
                requiredValueKind: node.valueKind,
                expectedSchemaRef: node.schemaRef,
                allowedActions: node.nextSteps.map(step => step.actionKind),
            }));
        }
        for (const child of node.children)
            visit(child);
    };
    visit(root);
    return gaps;
}
function collectCustomAppDevelopmentNextSteps(root) {
    const steps = [];
    const seen = new Set();
    const visit = (node) => {
        for (const step of node.nextSteps) {
            if (!seen.has(step.nextStepId)) {
                seen.add(step.nextStepId);
                steps.push(step);
            }
        }
        for (const child of node.children)
            visit(child);
    };
    visit(root);
    return steps;
}
function finalizeCustomAppDevelopmentTree(input) {
    const gaps = collectCustomAppDevelopmentGaps(input.root);
    const nextSteps = collectCustomAppDevelopmentNextSteps(input.root);
    return exports.CustomAppDevelopmentTreeSchema.parse({
        schemaVersion: exports.CUSTOM_APP_DEVELOPMENT_TREE_SCHEMA_VERSION,
        target: input.target,
        mode: input.mode,
        root: input.root,
        progress: calculateCustomAppDevelopmentProgress(input.root),
        gaps,
        nextSteps,
        diff: input.diff,
        recipe: input.recipe,
    });
}
